import { createSlice } from '@reduxjs/toolkit';

import { ThunkRequestStatus } from '@fora-monorepo/webapp-types';

import { getCountries, getSettings } from './foraGlobalThunks';
import { ForaGlobalState } from './types/index';

export const initialForaGlobalState: ForaGlobalState = {
  countries: [],
  settings: {
    monthlyReportingReleaseDate: '',
    highPayWarningLimit: undefined,
    draftTTL: 72,
    payMonthMargin: 12,
    ffSurveyMultiReporter: false,
    ffCompressFileUpload: false,
    ffChangeParameterEndDate: false,
    ffManageEmployeeAndEmployment: false,
    ffFaGroupIdOnEmployment: false,
  },
  loadingCountries: ThunkRequestStatus.Pending,
  loadingSettings: ThunkRequestStatus.Pending,
};

const foraGlobalSlice = createSlice({
  name: 'foraGlobal',
  initialState: initialForaGlobalState,
  reducers: {},
  extraReducers: builder => {
    // Get employer
    builder.addCase(getCountries.fulfilled, (state, action) => {
      if (action.payload) {
        state.loadingCountries = ThunkRequestStatus.Fulfilled;

        state.countries = action.payload;
      }
    });
    builder.addCase(getCountries.pending, state => {
      state.loadingCountries = ThunkRequestStatus.Pending;
    });
    builder.addCase(getCountries.rejected, state => {
      state.loadingCountries = ThunkRequestStatus.Rejected;
    });
    // Get settings
    builder.addCase(getSettings.fulfilled, (state, action) => {
      if (action.payload) {
        state.loadingSettings = ThunkRequestStatus.Fulfilled;

        state.settings = action.payload;
      }
    });
    builder.addCase(getSettings.pending, state => {
      state.loadingSettings = ThunkRequestStatus.Pending;
    });
    builder.addCase(getSettings.rejected, state => {
      state.loadingSettings = ThunkRequestStatus.Rejected;
    });
  },
});

export const foraGlobalReducer = foraGlobalSlice.reducer;
export default foraGlobalSlice.reducer; // for unit tests
